import React from 'react';
import PropTypes from "prop-types";
import {useDispatch} from "react-redux";

import MindsetsJsSDK, {
    LoadedAutocompleteItemsAction,
    LoadedAutocompleteTotalsAction,
    Autocomplete,
    filterConstants
} from "mindsets-js-sdk";

function PracticeSkillDropdown(
    {
        default_value,
        placeholder = 'Skill',
        container_class,
        input_class,
        show_add_always = false,
        label,
        label_class,
        renderAdd,
        onSelect,
        with_reset = false,
        id,
        disabled = false,
        match_dropdown_width = false,
        show_counts = false,
        onReset,
        debounce,
        limit = 25,
        practice_id
    }
) {
    const dispatch = useDispatch();

    function loadSkills(name) {
        let options = {limit}
        options['q'] = name;
        if (practice_id) {
            options['filters[practice_id][0]'] = filterConstants.EXPRESSION_EQUAL + '=' + practice_id;
        }

        MindsetsJsSDK().API
            .get('practice_skills', options)
            .then(response => {
                dispatch(LoadedAutocompleteItemsAction(id, response.items));
                dispatch(LoadedAutocompleteTotalsAction(id, response.total));
            });
    }

    function getSkills(name) {
        if (typeof debounce === 'function') {
            debounce(function () {
                loadSkills(name);
            });
        } else {
            loadSkills(name);
        }
    }

    function renderSkill(item) {
        return (
            <div>
                <div className="autocomplete-dropdown-menu-item-title">{item.code} {item.name}</div>
            </div>
        );
    }

    return (
        <Autocomplete
            id={id}
            placeholder={placeholder}
            fetchItems={getSkills}
            onSelect={onSelect}
            label={label}
            label_class={label_class}
            renderItem={renderSkill}
            default_value={default_value}
            persist_value={true}
            always_show_add={show_add_always}
            renderAdd={renderAdd}
            container_class={container_class}
            input_class={input_class}
            with_reset={with_reset}
            onReset={onReset}
            disabled={disabled}
            match_dropdown_width={match_dropdown_width}
            onChange={() => onSelect(null)}
            show_counts={show_counts}
        />
    );
}

PracticeSkillDropdown.propTypes = {
    default_value: PropTypes.string,
    placeholder: PropTypes.string,
    container_class: PropTypes.string,
    input_class: PropTypes.string,
    show_add_always: PropTypes.bool,
    label: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.object,
        PropTypes.element,
    ]),
    label_class: PropTypes.string,
    renderAdd: PropTypes.func,
    onSelect: PropTypes.func.isRequired,
    with_reset: PropTypes.bool,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    disabled: PropTypes.bool,
    match_dropdown_width: PropTypes.bool,
    show_counts: PropTypes.bool,
    onReset: PropTypes.func,
    debounce: PropTypes.func,
    limit: PropTypes.number,
    practice_id: PropTypes.number
};

export default PracticeSkillDropdown;
